import React, { Component } from "react";
import PropTypes from "prop-types";
import { DragSource, DropTarget } from "react-dnd";
import { Button } from "material-ui";
import RemoveIcon from "assets/images/remove.png";
import CInput from "uis/CInput";
import ItemTypes from "./ItemTypes";

const itemSource = {
  beginDrag(props) {
    return {
      id: props.id,
      originalIndex: props.findAttrItem(props.id).index
    };
  },

  endDrag(props, monitor) {
    const { id: droppedId, originalIndex } = monitor.getItem();
    const didDrop = monitor.didDrop();
    if (!didDrop) {
      props.moveAttrItem(droppedId, originalIndex);
    }
  }
};

const itemTarget = {
  canDrop() {
    return false;
  },

  hover(props, monitor) {
    const { id: draggedId } = monitor.getItem();
    const { id: overId } = props;

    if (draggedId !== overId) {
      const { index: overIndex } = props.findAttrItem(overId);
      props.moveAttrItem(draggedId, overIndex);
    }
  }
};

const dropTarget = connect => ({
  connectDropTarget: connect.dropTarget()
});
const dragSource = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
});

class AttrItem extends Component {
  render() {
    const {
      id,
      value,
      index,
      isDragging,
      changeAttrItem,
      removeAttrItem,
      connectDragSource,
      connectDropTarget,
      classes,
      localeNo,
    } = this.props;

    /**
     * Determines the department length based on locale.
     * @returns {number} The department length: 20 for Japanese locale,
     *                  40 for other locale.
     */
    const changeDepartmentLength = () => {
      return (localeNo === 'ja' || localeNo === 'zh') ? 20 : 40;
    };

    const opacity = isDragging ? 0.3 : 1;

    return connectDragSource(
      connectDropTarget(
        <div
          style={{
            padding: "0.5rem 1rem",
            border: "1px dashed gray",
            marginBottom: ".5rem",
            backgroundColor: "white",
            cursor: "default",
            outline: "none",
            opacity,
            position: "relative"
          }}
          key={`attrItem:${id}`}
        >
          <div
            className={classes.paperDesc}
            style={{ width: 20, display: "inline-block" }}
          >
            {index + 1}.
          </div>
          <CInput
            style={{ marginLeft: 20, width: 540 }}
            inputProps={{ maxLength: changeDepartmentLength() }}
            value={value}
            onChange={e => changeAttrItem(index, e.target.value)}
          />
          <Button
            dense
            raised
            style={{
              marginLeft: 15,
              minWidth: 40,
              verticalAlign: "sub",
              position: "absolute",
              right: 10
            }}
            onClick={() => removeAttrItem(index)}
          >
            <img
              style={{ height: 20, width: 20 }}
              alt="remove"
              src={RemoveIcon}
            />
          </Button>
        </div>
      )
    );
  }
}

AttrItem.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  id: PropTypes.any.isRequired,
  moveAttrItem: PropTypes.func.isRequired,
  findAttrItem: PropTypes.func.isRequired
};
export default DragSource(ItemTypes.ATTR_ITEM, itemSource, dragSource)(
  DropTarget(ItemTypes.ATTR_ITEM, itemTarget, dropTarget)(AttrItem)
);



// WEBPACK FOOTER //
// ./src/components/SetupAttr/AttrItem.jsx